module.exports = __webpack_public_path__ + "img/be.3428c9f0.svg";